import { axios } from '@/utils/request'


const api = {
  searchReportListForAdmin: '/report/searchReportListForAdmin',
  searchStudyListForAdmin: '/edu/getTaskContentListByContentType',
  searchMeasurementListForAdmin: '/edu/getTaskContentListByContentType',
  studymentListDetail: 'report/queryUserExeInfoByPage',
  measurementListDetail: 'report/searchTaskPaperScoreList',
  sendCrsDetailEmail: 'report/sendCrsDetailEmail',
  sendExamDetailEmail: 'report/sendExamDetailEmail'
}

export default api

export function searchReportListForAdmin(parameter) {
  return axios({
    url: api.searchReportListForAdmin,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: JSON.stringify(parameter)
  })
}

export function searchStudyListForAdmin(parameter) {
  return axios({
    url: api.searchStudyListForAdmin,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: JSON.stringify(parameter)
  })
}

export function searchMeasurementListForAdmin(parameter) {
  return axios({
    url: api.searchMeasurementListForAdmin,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: JSON.stringify(parameter)
  })
}

export function studymentListDetail(parameter) {
  return axios({
    url: api.studymentListDetail,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: JSON.stringify(parameter)
  })
}

export function measurementListDetail(parameter) {
  return axios({
    url: api.measurementListDetail,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: JSON.stringify(parameter)
  })
}

export function downloadTaskPaperScore(parameter) {
  return axios({
    url: api.downloadTaskPaperScore,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: JSON.stringify(parameter)
  })
}

export function sendCrsDetailEmail(parameter) {
  return axios({
    url: api.sendCrsDetailEmail,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: JSON.stringify(parameter)
  })
}

export function sendExamDetailEmail(parameter) {
  return axios({
    url: api.sendExamDetailEmail,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: JSON.stringify(parameter)
  })
}



